import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  renderSelectField,
  renderInputField,
  renderDropdown,
  renderCheckboxes,
} from '../../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import { setPatientData } from '../../../../actions';
import CustomSelectField from '../../../../common/CustomSelectField';
import DateComponent from '../../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';

// Custom styles
const useStyles = makeStyles(() => ({
  card: {
    marginBottom: '20px',
  },
  title: {
    marginBottom: '20px',
  },
  formControl: {
    width: '100%',
  },
  mandatoryField: {
    color: 'red',
  },
}));

export default function TreatmentPlanForm() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const patientData = useSelector(
    (state) => state.clinicalReducer.currentCycle.fmsData,
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(
      setPatientData(`currentCycle.fmsData.treatmentPlanForm.${name}`, value),
    );
  };

  const handleStimulationProtocolCheckboxChange = (e, index) => {
    const { name, checked } = e.target;

    if (checked) {
      const updatedCheckboxes = patientData.stimulationProtocol.map(
        (item, idx) =>
          idx === index
            ? { ...item, checked: true }
            : { ...item, checked: false },
      );

      dispatch(
        setPatientData(
          'currentCycle.fmsData.stimulationProtocol',
          updatedCheckboxes,
        ),
      );
    } else {
      const updatedCheckboxes = patientData.stimulationProtocol.map(
        (item, idx) => (idx === index ? { ...item, checked: false } : item),
      );

      dispatch(
        setPatientData(
          'currentCycle.fmsData.stimulationProtocol',
          updatedCheckboxes,
        ),
      );
    }

    if (name === 'otherValue') {
      dispatch(
        setPatientData(
          'currentCycle.fmsData.stimulationProtocolOther',
          e.target.value,
        ),
      );
    }
  };

  const [selectedDates, setSelectedDates] = useState(() => {
    return { treatmentPlanDate: null };
  });

  useEffect(() => {
    if (patientData.treatmentPlanForm) {
      const obj = {};
      const { treatmentPlanDate } = patientData.treatmentPlanForm;

      if (treatmentPlanDate && treatmentPlanDate != '') {
        obj[treatmentPlanDate] = dayjs(treatmentPlanDate);
      } else {
        obj[treatmentPlanDate] = null;
      }
      setSelectedDates({
        treatmentPlanDate: obj[treatmentPlanDate],
      });
    }
  }, [patientData]);
  const handleDateChange = (date, dateString, key) => {
    setSelectedDates({
      ...selectedDates,
      [key]: date,
    });
    handleInputChange({
      target: {
        name: key,
        value: dateString,
      },
    });
  };
  return (
    <div className="theme-blush">
      <div className="container-fluid">
        <div className="card">
          <div className="header">
            <p className="lead">Patient Treatment Plan</p>
          </div>
          <div className="body">
            <div className="card_name_container">
              <div style={{ flex: '1 1' }} className="form-group">
                <label htmlFor="treatmentPlanDate">Date</label>
                <DateComponent
                  id="treatmentPlanDate"
                  selectedDate={selectedDates['treatmentPlanDate']}
                  handleDateChange={(date, dateString) =>
                    handleDateChange(date, dateString, 'treatmentPlanDate')
                  }
                />
              </div>
              {/* LMP Field */}
              {renderInputField(
                'LMP',
                'lmp',
                patientData.treatmentPlanForm.lmp,
                handleInputChange,
              )}

              {/* AMH Field */}
              {renderInputField(
                'AMH',
                'amh',
                patientData.treatmentPlanForm.amh,
                handleInputChange,
              )}

              {/* Diagnosis Field */}
              {renderInputField(
                'Diagnosis',
                'diagnosis',
                patientData.treatmentPlanForm.diagnosis,
                handleInputChange,
              )}
              <CustomSelectField
                label="Treatment Plan"
                name="customTreatmentPlan"
                value={patientData.treatmentPlanForm.customTreatmentPlan}
                onChange={handleInputChange}
                options={['NC', 'OI', 'IUI', 'FET', 'IVF']}
                isOtherValue={true}
                otherValue={
                  patientData.treatmentPlanForm.customTreatmentPlanOther
                }
              />

              {/* {
              renderSelectField(
                'Medication',
                'Medication',
                patientData.treatmentPlanForm.Medication,
                handleInputChange,
                true,
              )
            } */}
            </div>
            <div className="card_name_container">
              {renderCheckboxes(
                patientData.stimulationProtocol,
                handleStimulationProtocolCheckboxChange,
                'Stimulation Protocol',
                'stimulationProtocol',
                patientData.stimulationProtocolOther,
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
